import { useTranscriptMetadata } from 'src/contexts/Transcript/MetadataContext'
import { useFeatureFlag } from 'src/contexts/FeatureFlagContext'
import { useUserContext } from 'src/contexts/UserProvider'
import { isChromakeyModeActive, isUserSpeaker } from 'src/utils/env'
import { UserRole, isUserWithRoles } from 'src/models/User'

const isSpeaker = isUserSpeaker()

export const ROLES_THAT_CAN_RECORD: UserRole[] = [
    'customer_admin',
    'customer_live_participant',
    'customer_content_manager',
    'collection_manager',
    'court_reporter',
]

export const ROLES_THAT_CAN_GO_OFF_RECORD: UserRole[] = [
    'customer_admin',
    'customer_live_participant',
    'customer_content_manager',
    'collection_manager',
    'court_reporter',
]

export const useVerbitConnectAvailability = () => {
    const metadata = useTranscriptMetadata()
    const { isUserFetched, user } = useUserContext()

    const baselineConditions = !!metadata?.orderId && !isChromakeyModeActive

    const isMediaRecorderAvailable =
        baselineConditions &&
        isSpeaker &&
        isUserWithRoles(user, ROLES_THAT_CAN_RECORD) &&
        isUserFetched &&
        user?.customerId === metadata.customerId &&
        metadata.inputType === 'onsite'

    const isMediaPlayerFeatureEnabled = useFeatureFlag('media_player')
    const isMediaPlayerAvailable = baselineConditions && isMediaPlayerFeatureEnabled

    const isMediaSourceFeatureEnabled = useFeatureFlag('media_source')
    const isMediaSourceAvailable = baselineConditions && isMediaSourceFeatureEnabled && metadata.inputType !== 'onsite'

    return {
        isMediaRecorderAvailable,
        isMediaPlayerAvailable,
        isMediaSourceAvailable,
    }
}
